import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as PXBColors from '@brightlayer-ui/colors';
const deviceStyles = makeStyles((theme: Theme) =>
    createStyles({
        lineItemTitle: {
            fontWeight: 600,
            marginTop: 6,
            lineHeight: 1,
        },
        lineItemSubTitle: {
            marginRight: 100,
            fontWeight: 400,
        },
        listLineHeight: { lineHeight: 1.25 },
        fontWeight600: { fontWeight: 600 },
        marginLeft5: { marginLeft: 5 },
        rightPosition: {
            display: 'flex',
            alignItems: 'center',
        },
        addUserformControl: {
            minWidth: 120,
        },
        fullWidth: {
            width: '100%',
        },
        halfWidth: {
            width: '48%',
        },
        marginLeft16: { marginLeft: 16 },
        margin16: { margin: 16 },
        margin8: { margin: 8 },
        wrapText: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },

        iconVisibilityHidden: {
            visibility: 'hidden',
        },
        iconVisibility: {
            visibility: 'visible',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        padding8: { padding: 8 },
        padding16: { padding: 16 },

        avatar: {
            backgroundColor: PXBColors.blue[400],
            color: PXBColors.white[500],
        },
        equalSpacing: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        iconRightEnd: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
        },
        rightSideButtonPosition: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '16px',
        },
        heightAuto: {
            height: 'auto',
        },
        paddingTextbox: {
            padding: '16px 8px',
        },
    })
);

export default deviceStyles;
